import { render, staticRenderFns } from "./SleepApneaCard.vue?vue&type=template&id=209b719a&"
import script from "./SleepApneaCard.vue?vue&type=script&lang=js&"
export * from "./SleepApneaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports